import React, { MouseEventHandler } from 'react';
import { Box } from '@mui/material';

const CloseIconButton: React.FC<{
  setShowInfo?: MouseEventHandler;
  width?: string;
  height?: string;
  fill?: string;
  hoverColor?: string;
}> = ({
  setShowInfo,
  width = '26px',
  height = '26px',
  fill = '#FFF',
  hoverColor = '#DBD8DF',
}): React.ReactElement => {
  return (
    <Box
      onClick={setShowInfo}
      sx={{
        cursor: 'pointer',
        padding: '4px 16px',
        borderRadius: '8px',
        border: `1px solid ${fill}`,
        '&:hover': {
          background: 'rgba(255, 65, 65, 0.2)',
          border: `1px solid ${hoverColor}`,
          color: hoverColor,
          '& svg': {
            fill: hoverColor,
          },
        },
      }}>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26">
          <path
            fill={fill}
            fillRule="evenodd"
            d="M23.457.476l2.298 2.298-10.341 10.341 10.341 10.342-2.298 2.298-10.342-10.341L2.774 25.755.476 23.457l10.341-10.342L.476 2.774 2.774.476l10.341 10.341L23.457.476z"
          />
        </svg>
      </span>
    </Box>
  );
};

export default CloseIconButton;
